module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel-suns_spot_04-d509b3174a900ea9d2ec65ee29ee4401.jpg";